import {EventBase} from "shared/utilities/Events/EventManager";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";




export class GetControl extends EventBase {
    ReturnType: PDFControlBase;

    constructor(public Type:string) {
        super();
    }

    public static GetName() {
        return 'GetControl';
    }
}